import { InputAdornment } from "@material-ui/core";
import { DeleteOutlineOutlined } from "@material-ui/icons";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import {
  AsyncSelect,
  Button,
  Checkbox,
  EditableText,
  FlashMessage,
  Input,
  Modal,
  Radio,
  SelectNew,
  SingleFileDropZone,
} from "../../components/common";
import { useForm } from "react-hook-form";
import httpRequest from "../../utils/httpRequest";
import API_URLS from "../../utils/apiUrls";
import {
  EMPLOYEE_SIZE_OPTIONS,
  Hiring_Type,
  INDUSTRY_OPTIONS,
  PROJECT_TIME_OPTIONS,
  REMOTE_CHOICE,
  VISA_TYPE_OPTIONS,
} from "../../utils/appConstants";
import { useNavigate, useLocation } from "react-router-dom";
import AutoModeIcon from "@material-ui/icons/Loop";
import salesInfoImg from "../../assets/images/sales-info.png";
import salesInfoMobile from "../../assets/images/sales-info-mobile.png";
import emailThankyouImg from "../../assets/images/email-thankyou-icon.png";
import appRoutes from "../../routes/app.routes";
import commonServices from "../../services/common.services";
import currenciesServices from "../../services/currencies.services";
import contactUsServices from "../../services/contactUs.services";
import UploadResume from "../../components/ProfileViewNew/icons/upload-resume-icon.svg";

const ContactUsSales = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset: resetForm,
    getValues,
  } = useForm({});

  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const [hiringType, setHiringType] = useState<string>("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState();
  const [services, setServices] = useState<string[]>([]);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [imageSrc, setImageSrc] = useState<string>(salesInfoImg);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);
  const [jobDescriptionFile, setJobDescriptionFile] = useState<string | null>(
    null
  );
  const [jobDescriptionFileName, setJobDescriptionFileName] = useState<string | null>(
    null
  );
  const [jobDescriptionPreviewUrl, setJobDescriptionPreviewUrl] = useState<
    string | null
  >(null);

  let searchDelay: NodeJS.Timeout;

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth <= 991) {
        setImageSrc(salesInfoMobile);
      } else {
        setImageSrc(salesInfoImg);
      }
    };

    updateImage(); // Initial check
    window.addEventListener("resize", updateImage); // Listen for window resize

    return () => window.removeEventListener("resize", updateImage); // Cleanup
  }, []);

  const staffingList = [
    "Enhance and expand your current workforce",
    "Provide specialized expertise for short or long-term projects",
    "Recruit and screen top-tier talent for permanent roles",
  ];
  const designBuildList = [
    "Network architecture and deployment",
    "Application development and optimization",
    "Web development and testing",
    "Deployment planning and migration",
  ];

  useEffect(() => {
    if (path === "/contact-us/sales") {
      createCaptcha();
    }
  }, [path]);

  const SaveReview = async (formData) => {
    const captcha = formData.captcha_answer;
    setSubmitLoader(true);
    if (captcha === captchaAnswer) {
      // const payload = {
      //   name: formData.name,
      //   company_name: formData.company_name,
      //   company_email: formData.company_email,
      //   company_size: parseInt(formData.company_size.value),
      //   contact_info: formData.contact_info,
      //   company_url: formData.company_url,
      //   industry_id: parseInt(formData.industry.value),
      //   services: services,
      //   hiring_type: hiringType,
      //   message: message,
      //   isAuthorized: isAuthorized,
      // };
      const payload = {
        name: formData.name,
        company_name: formData.company_name,
        company_email: formData.company_email,
        company_size: parseInt(formData.company_size.value),
        contact_info: formData.contact_info,
        company_url: formData.company_url,
        job_title: formData.job_title,
        project_time: parseInt(formData.project_time?.value || 0),
        city_id: _.get(formData, "city_id.value", ""),
        is_remote: _.get(formData, "is_remote.value", ""),
        budget_min: parseInt(formData.budget_min || 0, 10),
        budget_max: parseInt(formData.budget_max || 0, 10),
        currency_id: parseInt(_.get(formData, "currency_id.value", 0), 10),
        visa_type: _.get(formData, "visa_type.value", ""), // ⬅️ new
        number_of_hires: formData.number_of_hires || null, // ⬅️ new
        industry_id: parseInt(formData.industry.value),
        services: services,
        hiring_type: hiringType,
        message: formData.message,
        isAuthorized: isAuthorized,
        job_description_file: jobDescriptionFile,
      };

      try {
        const response = await httpRequest().post(
          `${API_URLS.Inquiry}`,
          payload
        );
        if (response.data?.status === 200) {
          FlashMessage(response.data?.message);
            const saleId = _.get(response, "data.data.sale_id", null); // 👈 make backend return this

          // resetForm({
          //   name: "",
          //   company_name: "",
          //   company_email: "",
          //   company_size: "",
          //   contact_info: "",
          //   company_url: "",
          //   industry: "",
          //   captcha_answer: "",
          // });
          resetForm({
            name: "",
            company_name: "",
            company_email: "",
            company_size: "",
            contact_info: "",
            company_url: "",
            job_title: "",
            project_time: "",
            city_id: "",
            is_remote: "",
            budget_min: "",
            budget_max: "",
            currency_id: "",
            visa_type: "", // ⬅️ new
            number_of_hires: "", // ⬅️ new
            industry: "",
            captcha_answer: "",
            message: "",
          });

          setServices([]);
          setJobDescriptionFile(null);
          setJobDescriptionFileName(null);
          if (jobDescriptionPreviewUrl) {
            URL.revokeObjectURL(jobDescriptionPreviewUrl);
          }
          setJobDescriptionPreviewUrl(null);
          setSuccessModal(true);
          setSubmitLoader(false);
          if (saleId) {
    // go straight to Book Call page
    navigate(appRoutes.salesBookCall.generatePath().replace(":saleId", String(saleId)));
  } else {
    // fallback: show your old thank-you modal
    setSuccessModal(true);
  }
        }
        return response;
      } catch (error) {
        const errorList = error?.response?.data?.errors || {};
        setSubmitLoader(false);
        if (Object.values(errorList).length > 0) {
          const firstError = Object.values(errorList)[0] as string;
          FlashMessage(firstError, "error");
        } else {
          FlashMessage(error.response.data.message, "error");
        }
      }
    } else {
      setSubmitLoader(false);
      FlashMessage("Please Enter Valid Captcha", "error");
    }
  };

  const createCaptcha = async () => {
    const data = await httpRequest().post(API_URLS.captcha);
    const svgImage = data.data.data.data;
    const responseCaptchaAnswer = data.data.data.text;
    setCaptchaAnswer(responseCaptchaAnswer);
    setCaptchaImage(svgImage);
  };

  const handleServiceChange = (e: any) => {
    const { name, checked } = e.target;
    setServices((prev) =>
      checked ? [...prev, name] : prev.filter((service) => service !== name)
    );
    // setIsAuthorized(!isAuthorized);
  };

  const searchLocations = (search: string) =>
    new Promise((resolve) => {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(async () => {
        const locationData = await commonServices.fetchLocationsPublic(search);
        const locations = _.get(locationData, "data.data", []).map((c:any) => ({
          value: c.id,
          label: c.location,
        }));

        resolve(locations);
      }, 1000);
    });

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await currenciesServices.getCurrencies();
        if (res.flag) {
          const list = res.data || [];
          const options = list.map((c:any) => ({
            value: String(c.id),
            // 👇 This matches your design:
            // USD – US Dollar ($)
            label: `${c.code} \u2013 ${c.name} (${c.symbol})`,
          }));
          setCurrencyOptions(options);
        } else {
          FlashMessage(res.message || "Unable to load currencies", "error");
        }
      } catch (e) {
        FlashMessage("Unable to load currencies", "error");
      }
    };

    fetchCurrencies();
  }, []);

  const jobDescriptionUploadSuccess = async (file: File) => {
    try {
      if (jobDescriptionPreviewUrl) {
        URL.revokeObjectURL(jobDescriptionPreviewUrl);
      }

      const isImage = (file.type || "").indexOf("image/") === 0;
      setJobDescriptionPreviewUrl(isImage ? URL.createObjectURL(file) : null);
      setJobDescriptionFileName(file.name || null);

      const payload = new FormData();
      payload.append("files", file);

      const uploadRes = await contactUsServices.salesFileUpload(payload);

      if (uploadRes.flag) {
        setJobDescriptionFile(_.get(uploadRes, "data.encFileName", null));
      } else {
        FlashMessage(uploadRes.message || "Unable to upload file", "error");
      }
    } catch (e) {
      FlashMessage("Unable to upload file. Please try again.", "error");
    }
  };

  const handleRemoveJobDescription = useCallback(() => {
    if (jobDescriptionPreviewUrl) {
      URL.revokeObjectURL(jobDescriptionPreviewUrl);
    }
    setJobDescriptionPreviewUrl(null);
    setJobDescriptionFileName(null);
    setJobDescriptionFile(null);
  }, [jobDescriptionPreviewUrl]);

  useEffect(() => {
    return () => {
      if (jobDescriptionPreviewUrl) {
        URL.revokeObjectURL(jobDescriptionPreviewUrl);
      }
    };
  }, [jobDescriptionPreviewUrl]);

  return (
    <div className="main-inquiry-container">
      <div className="left-side">
        <img src={imageSrc} alt="sales-info" />
      </div>
      <div className="right-side">
        <h2>How Can We Help?</h2>
        <p>Reach out, and we’ll get back to you within 24 hours!</p>
        <form noValidate onSubmit={(e) => handleSubmit(SaveReview)(e)}>
          <div className="form-wrapper">
            <div className="form-group two-cols">
              <div className="form-field">
                <Input
                  // name="name"
                  externalLabel={{ label: "Customer Name", className: "required" }}
                  placeholder="Full name"
                  validationObj={errors}
                  {...register("name", {
                    required: {
                      value: true,
                      message: "Please enter full name",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9\s]*$/,
                      message: "Name should not contain special characters",
                    },
                  })}
                />
              </div>
              <div className="form-field">
                <Input
                  // name="company_name"
                  externalLabel={{ label: "Company Name", className: "required" }}
                  placeholder="Company name"
                  validationObj={errors}
                  {...register("company_name", {
                    required: {
                      value: true,
                      message: "Please enter company name",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9\s]*$/,
                      message: "Company name should not contain special characters",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-group">
              <Input
                // name="company_email"
                type="email"
                externalLabel={{ label: "Company Email Address", className: "required" }}
                placeholder="Email address"
                validationObj={errors}
                {...register("company_email", {
                  required: {
                    value: true,
                    message: "Please enter company email",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                })}
              />
            </div>
            <div className="form-group two-cols">
              <div className="form-field">
                <SelectNew
                  name="company_size"
                  externalLabel={{ label: "Company Size", className: "required" }}
                  placeholder="Select company size"
                  className="select-box"
                  options={EMPLOYEE_SIZE_OPTIONS}
                  isSearchable={true}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select company size",
                    },
                  }}
                />
              </div>
              <div className="form-field phone-number-input">
                <label className="required">Phone Number</label>
                <EditableText
                  inputClassName="editable-input"
                  control={control}
                  name="contact_info"
                  country="us"
                  error={errors.contact_info}
                  rules={{
                    required: {
                      value: true,
                      message: "Phone number is required",
                    },
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <Input
                // name="company_url"
                externalLabel={{ label: "Company Website", className: "required" }}
                placeholder="Website URL"
                validationObj={errors}
                {...register("company_url", {
                  required: {
                    value: true,
                    message: "Please enter company website URL",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?(www\.)?([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/,
                    message: "Please enter a valid website URL",
                  },
                })}
              />
            </div>
            {/* <div className="form-group">
              <label className="custom-label">
                Upload Job Description{" "}
                <span>(PDF, DOC, or DOCX Files Are Allowed)</span>
              </label>
              <div className="custom-input-type-file job-description-upload">
                <SingleFileDropZone
                  allowFileTypes={["pdf", "doc", "docx"]}
                  allowFileSize={5 * 1024 * 1024} // 5 MB, adjust if needed
                  // onSuccess={jobDescriptionUploadSuccess}
                />
              </div>
            </div> */}

            {/* Job Title + Project Time (already added) */}
            <div className="form-group two-cols">
              <div className="form-field">
                <Input
                  externalLabel={{ label: "Job Title", className: "required" }}
                  placeholder="Name of the job"
                  validationObj={errors}
                  {...register("job_title", {
                    required: {
                      value: true,
                      message: "Please enter job title",
                    },
                  })}
                />
              </div>

              <div className="form-field">
                <SelectNew
                  name="project_time"
                  externalLabel={{ label: "Project Time", className: "required" }}
                  placeholder="Enter time"
                  className="select-box"
                  options={PROJECT_TIME_OPTIONS}
                  isSearchable={false}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select project time",
                    },
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="custom-label">Upload Job Description</label>
              <div className="custom-input-type-file">
                {jobDescriptionFileName ? (
                  jobDescriptionPreviewUrl ? (
                    <div className="feedback-image-preview-wrapper">
                      <div className="feedback-image-preview">
                        <img
                          src={jobDescriptionPreviewUrl}
                          alt={jobDescriptionFileName}
                        />
                        <button
                          type="button"
                          className="feedback-image-delete"
                          onClick={handleRemoveJobDescription}
                          aria-label="Remove file"
                        >
                          <DeleteOutlineOutlined />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="job-description-file-preview">
                      <span className="attachment-file-name">
                        {jobDescriptionFileName}
                      </span>
                      <button
                        type="button"
                        className="feedback-image-delete"
                        onClick={handleRemoveJobDescription}
                        aria-label="Remove file"
                      >
                        <DeleteOutlineOutlined />
                      </button>
                    </div>
                  )
                ) : (
                  <SingleFileDropZone
                    allowFileTypes={["png", "jpg", "jpeg", "pdf", "doc", "docx"]}
                    allowFileSize={1048576}
                    onSuccess={jobDescriptionUploadSuccess}
                    content={
                      <div className="upload-job-description-content">
                        <div className="icon">
                          <img src={UploadResume} alt="icon" />
                        </div>
                        <p>
                          Drag and drop your file here or <span>browse</span> to
                          upload.
                        </p>
                        <span>(PDF, DOC, or DOCX Files Are Allowed)</span>
                      </div>
                    }
                  />
                )}
              </div>
            </div>

            {/* ⬇️ NEW: Location + Location Type */}
            <div className="form-group two-cols">
              <div className="form-field">
                <AsyncSelect
                  name="city_id"
                  placeholder="Enter location"
                  externalLabel={{ label: "Location", className: "required" }}
                  onStartSearching={searchLocations}
                  validationObj={errors}
                  control={control}
                  noOptionsMessage="No matching locations found"
                  rules={{
                    required: {
                      value: true,
                      message: "Please select location from list",
                    },
                  }}
                />
              </div>

              <div className="form-field">
                <SelectNew
                  name="is_remote"
                  externalLabel={{ label: "Location Type", className: "required" }}
                  placeholder="Select type"
                  className="select-box"
                  options={REMOTE_CHOICE}
                  isSearchable={true}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select location type",
                    },
                  }}
                />
              </div>
            </div>
            {/* ⬇️ NEW: Budget + Currency */}
            <div className="form-group three-cols">
              <div className="form-field">
                <Input
                  type="number"
                  min={0}
                  externalLabel={{ label: "Budget Min", className: "required" }}
                  placeholder="Min range"
                  validationObj={errors}
                  {...register("budget_min", {
                    required: {
                      value: true,
                      message: "Please enter budget min",
                    },
                    validate: (value) => {
                      return value > parseFloat(getValues("budget_max")) ? "Min budget cannot be greater than max budget" : true;
                    },
                  })}
                />
              </div>

              <div className="form-field">
                <Input
                  type="number"
                  min={0}
                  externalLabel={{ label: "Budget Max", className: "required" }}
                  placeholder="Max range"
                  validationObj={errors}
                  {...register("budget_max", {
                    required: {
                      value: true,
                      message: "Please enter budget max",
                    },
                    validate: (value) => {
                      return value < parseFloat(getValues("budget_min")) ? "Max budget cannot be less than min budget" : true;
                    },
                  })}
                />
              </div>

              <div className="form-field">
                <SelectNew
                  name="currency_id"
                  externalLabel={{ label: "Currency", className: "required" }}
                  placeholder="Select currency"
                  className="select-box"
                  options={currencyOptions}
                  isSearchable={true}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select currency",
                    },
                  }}
                />
              </div>
            </div>
            {/* ⬇️ NEW: Visa Type + Number of Hires */}
            <div className="form-group two-cols">
              <div className="form-field">
                <SelectNew
                  name="visa_type"
                  externalLabel={{ label: "Visa Type", className: "required" }}
                  placeholder="Visa type"
                  className="select-box"
                  options={VISA_TYPE_OPTIONS}
                  isSearchable={false}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select visa type",
                    },
                  }}
                />
              </div>

              <div className="form-field">
                <Input
                  type="number"
                  min={1}
                  externalLabel={{ label: "Number of Hires", className: "required" }}
                  placeholder="Enter number"
                  validationObj={errors}
                  {...register("number_of_hires", {
                    required: {
                      value: true,
                      message: "Please enter number of hires",
                    },
                    min: {
                      value: 1,
                      message: "Number of hires must be at least 1",
                    },
                    validate: (value) => {
                      const num = Number(value);
                      if (value === "" || value === null || value === undefined || isNaN(num)) {
                        return "Please enter number of hires";
                      }
                      if (num < 1) {
                        return "Number of hires must be at least 1";
                      }
                      return true;
                    },
                  })}
                />
              </div>
            </div>

            <div className="form-group two-cols">
              <div className="form-field">
                <SelectNew
                  name="industry"
                  externalLabel={{ label: "Industry", className: "required" }}
                  placeholder="Select industry"
                  className="select-box"
                  options={INDUSTRY_OPTIONS}
                  isSearchable={true}
                  validationObj={errors}
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please enter industry",
                    },
                  }}
                />
              </div>
              <div className="radio-wrapper">
                <label className="required">Hiring Type</label>
                <Radio
                  name="hiring_type"
                  control={control}
                  validationObj={errors}
                  labelPlacement="end"
                  wrapperClassName="gender-radio-wrapper w-100"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setHiringType(_.get(e, "target.value", ""));
                  }}
                  // inputRef={register({
                  //   required: {
                  //     value: true,
                  //     message: "Please select a role",
                  //   },
                  // })}
                  rules={{
                    required: {
                      value: true,
                      message: "Please select hiring type",
                    },
                  }}
                  options={Hiring_Type}
                />
              </div>
            </div>
            <div className="checkbox-card-wrapper">
              <p>
                We’re here to support your growth and success. Let us know how
                we can assist!
              </p>
              <div className="form-group two-cols">
                <div
                  className={`form-field checkbox-card ${
                    services.includes("staffing_solution") ? "active" : ""
                  }`}
                >
                  <Checkbox
                    name="staffing_solution"
                    externalLabel={{
                      label: "Staffing Solutions",
                    }}
                    color="primary"
                    inputRef={register("staffing_solution")}
                    onChange={handleServiceChange}
                  />
                  <p>
                    Our employHER Teams™ are ready to step in and drive your
                    business success. Whether you need contingent staff or
                    permanent hires, rely on us to
                  </p>
                  <ul>
                    {staffingList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div
                  className={`form-field checkbox-card ${
                    services.includes("design_build_solution") ? "active" : ""
                  }`}
                >
                  <Checkbox
                    name="design_build_solution"
                    externalLabel={{
                      label: "Design & Build Solution",
                    }}
                    color="primary"
                    wrapperClassName="gender-radio-wrapper w-100"
                    labelClassName="gender-radio"
                    inputRef={register("design_build_solution")}
                    onChange={handleServiceChange}
                  />
                  <p>
                    Our employHER Teams™ design, build, and optimize technology
                    and business processes to meet your goals. Trust us to
                    deliver exceptional results in:
                  </p>
                  <ul>
                    {designBuildList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-field">
                <Input
                  multiline={true}
                  rows={7}
                  className="feedback-description"
                  externalLabel={{ label: "Message", className: "required" }}
                  placeholder="How did you hear about employHER?"
                  validationObj={errors}
                  {...register("message", {
                    required: {
                      value: true,
                      message: "Please enter a message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="captcha-view-sales">
                <div
                  dangerouslySetInnerHTML={{
                    __html: captchaImage,
                  }}
                />

                <Input
                  // name="captcha_answer"
                  placeholder="Enter Captcha Answer"
                  validationObj={errors}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AutoModeIcon
                          className="captcha-icon"
                          onClick={() => createCaptcha()}
                        />
                      </InputAdornment>
                    ),
                  }}
                  {...register("captcha_answer", {
                    required: {
                      value: true,
                      message: "Please enter captcha answer",
                    },
                    pattern: {
                      value: /[0-9]+/,
                      message: "Enter valid captcha answer",
                    },
                    validate: (value) =>
                      value === captchaAnswer ||
                      "The verify captcha do not match",
                  })}
                />
              </div>
            </div>

            <div className="form-group authorize">
              {/* <Checkbox
                name="authorize"
                externalLabel={{
                  label:
                    "I authorize employHER to store and retain my personal data. By providing your phone number and other information, you agree to be contacted via email, phone, and SMS.",
                }}
                color="primary"
                wrapperClassName="gender-radio-wrapper w-100"
                labelClassName="gender-radio"
                inputRef={register("")}
                onChange={ (e)=> {setIsAuthorized(!isAuthorized)}}
              /> */}
              <Checkbox
                name="authorize"
                externalLabel={{
                  label:
                    "I authorize employHER to store and retain my personal data. By providing your phone number and other information, you agree to be contacted via email, phone, and SMS.",
                }}
                color="primary"
                checked={isAuthorized}
                onChange={(e) => setIsAuthorized(e.target.checked)}
              />
            </div>
            <div className="cal-line">
              <span className="cal-bullet"></span>
              <span>
                We’ll show a live calendar to book a call after you submit.
              </span>
            </div>
            <div className="form-actions">
              <Button
                type="submit"
                color="primary"
                loading={submitLoader}
                disabled={!isAuthorized}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </div>
      <Modal
        className="sales-success-modal"
        visible={successModal}
        size={"large"}
        closeButton={true}
        closeOnBackDrop={successModal}
        onClose={() => setSuccessModal(false)}
      >
        <div className="modal-head">
          <img src={emailThankyouImg} alt="email thankyou" />
        </div>
        <div className="modal-content-wrapper">
          <div className="modal-content">
            <h3>Thank You for Contacting</h3>
            <p>
              Your message has been sent to our Sales and Recruiting Team. We’ll
              get back to you within 24 hours.
            </p>
            <Button
              type="button"
              color="primary"
              onClick={() => {
                navigate(appRoutes.contactUs.path);
                setSuccessModal(false);
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContactUsSales;
